import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "./pages/Home";
import Packages from "./pages/packages";
import Swal from "sweetalert2";
import "./App.css";
import { LoadingProvider } from "./contexts/LoadingContext";
import Loader from "./components/loader";
import InsuranceScreen from "./pages/InsuranceScreen";
import PaymentConfirm from "./pages/payment-confirm";
import MyActivePackages from "./pages/my-packages";
import TransactionList from "./pages/transaction-list";
import StepRangeSlider from "./pages/range-slider";
import Decryption from "./pages/Decryption";
import Otpscreen from "./pages/otpscreen";


function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  const ActivePackageFilter = ({ children }) => {
    const session = JSON.parse(sessionStorage.getItem("user"));
    const navigate = useNavigate();

    useEffect(() => {
      if (!session?.package) {
        Swal.fire({
          icon: "info",
          title: "Package Subscription",
          text: "Sorry, you do not have an active subscription. Please subscribe to a package to access.",
          showCancelButton: true,
          confirmButtonText: "Buy Package",
          cancelButtonText: "Back",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/insurancescreen/calladoc/70");
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            navigate(-1);
          }
        });
      }
    }, [session, navigate]);

    return session && session.package ? children : null;
  };

  const ActiveProtectedRoute = ({ children }) => {
    const session = JSON.parse(sessionStorage.getItem("userData"));
    const navigate = useNavigate();

    useEffect(() => {
      if (session?.package) {
        Swal.fire({
          icon: "info",
          title: "Subscription",
          text: "You already have an active subscription.",
          confirmButtonText: "OK",
        }).then(() => {
          navigate(-1);
        });
      }
    }, [session, navigate]);

    return !session?.package ? children : null;
  };

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "Home page";
        metaDescription = "This is home page.";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  // const Auth = () => {
  //   window.location.href = "https://demo.webdoc.com.pk/auth.php";
  //   return null;
  // };

  return (
    <LoadingProvider>
      <Loader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/insurancescreen/:type/:id" element={<InsuranceScreen />}/>
        <Route path="/confrim" element={<PaymentConfirm />} />
        <Route path="/my-packages/:serviceId" element={<MyActivePackages />} />
        <Route path="/my-transaction" element={<TransactionList />} />
        <Route path="/Decryption" element={<Decryption />} />
        <Route path="/range-slider" element={<StepRangeSlider />} />
        <Route path="/otpscreen" element={<Otpscreen />} />
   
      </Routes>
    </LoadingProvider>
  );
}

export default App;
